import React from 'react';

export const BRAND_NAME = 'MAXLIGHT HRVATSKA';

export const Brand = ({ placement }) => (
  <span className={`brand-lockup brand-lockup--${placement}`}>
    <img
      src="/brand/maxlight-hrvatska-logo.webp"
      alt={BRAND_NAME}
      width="512"
      height="512"
      className="brand-logo"
      data-testid={`${placement}-brand-logo`}
    />
    <span className="brand-wordmark" aria-hidden="true" data-testid={`${placement}-brand-name`}>
      <span>MAXLIGHT</span>
      <span className="brand-country">HRVATSKA</span>
    </span>
  </span>
);